<script lang="ts">
// Used to render html and vue components from a string

  import { compile, h } from 'vue'

  import { useSanitizer } from '@/composables/useSanitizer'

  export default {
    props: {
      richText: {
        type: String,
        default: ''
      }
    },
    methods: {
      wrapTablesWithDivElements(doc: globalThis.Document) {
        // Find all <table> elements within the parsed HTML
        const tables = doc.querySelectorAll('table')
        // Wrap each <table> element with a <div>
        tables.forEach((table) => {
          const div = document.createElement('div')
          div.classList.add('table-wrapper')
          if (table.parentNode)
            table.parentNode.replaceChild(div, table)
          div.appendChild(table)
        })
      },
      // The reason for doing this is to make the <read-more> button appear
      // inline with the text in a paragraph, giving the appearance
      // that it is connected to the rest of the sentence.
      appendReadMoreButtonToPreviousParagraph(doc: globalThis.Document) {
        const readMoreButtons = doc.querySelectorAll('read-more')
        readMoreButtons.forEach((button) => {
          const previousElement = button.previousElementSibling
          if (previousElement) {
            previousElement.appendChild(button)
          }
        })
      },
      restructureHtml(html: string) {
        const parser = new DOMParser()
        const doc = parser.parseFromString(html, 'text/html')
        this.wrapTablesWithDivElements(doc)
        this.appendReadMoreButtonToPreviousParagraph(doc)
        // Convert the restructured DOM back to an HTML string
        return doc.body.innerHTML
      },
    },
    render() {
      if (!this.richText) return null
      const { sanitize } = useSanitizer()
      const sanitizedRichText = sanitize(this.richText)
      const restructuredContent = this.restructureHtml(sanitizedRichText)
      return h(compile(restructuredContent))
    },
  }
</script>

<style lang="scss" scoped>
  .cms-a {
    @include richtext-link;
  }
</style>
<style lang='scss'>
  @import "src/styles/table";

  .table-wrapper {
    width: 100%;
    display: block;
    overflow-x: auto;
    margin: 40px 0;

    @include vgs-media-mobile {
      width: 90%;
      margin: 0 auto;
    }
  }
</style>
